class ReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.rc-track');
    this.slides = [...this.querySelectorAll('.rc-slide')];
    this.dotsContainer = this.querySelector('[data-dots]');
    this.prevBtn = this.querySelector('[name="previous"]');
    this.nextBtn = this.querySelector('[name="next"]');
    this.currentPage = 0;
    this.scrollTimer = null;

    if (!this.slider || !this.slides.length) return;

    this.renderDots();

    this.prevBtn.addEventListener('click', () => this.goToPage(this.currentPage - 1));
    this.nextBtn.addEventListener('click', () => this.goToPage(this.currentPage + 1));

    this.slider.addEventListener('scroll', () => {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => this.onScroll(), 50);
    });

    new ResizeObserver(() => this.onResize()).observe(this);
  }

  getSlidesPerPage() {
    return 2;
  }

  getTotalPages() {
    return Math.ceil(this.slides.length / this.getSlidesPerPage());
  }

  renderDots() {
    const total = this.getTotalPages();
    this.dotsContainer.innerHTML = '';
    for (let i = 0; i < total; i++) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'slider-counter__link slider-counter__link--dots';
      btn.setAttribute('aria-label', `Page ${i + 1} of ${total}`);
      btn.innerHTML = `<span class="dot"></span><span class="visually-hidden">Page ${i + 1}</span>`;
      btn.addEventListener('click', () => this.goToPage(i));
      this.dotsContainer.appendChild(btn);
    }
    this.updateState();
  }

  goToPage(page) {
    const total = this.getTotalPages();
    page = Math.max(0, Math.min(page, total - 1));
    const slideIndex = page * this.getSlidesPerPage();
    const slide = this.slides[slideIndex];
    if (slide) {
      this.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    this.currentPage = page;
    this.updateState();
  }

  onScroll() {
    const spp = this.getSlidesPerPage();
    const slide = this.slides[0];
    if (!slide) return;
    const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
    const pageWidth = slide.offsetWidth * spp + gap * (spp - 1);
    if (pageWidth <= 0) return;
    const page = Math.min(
      Math.round(this.slider.scrollLeft / pageWidth),
      this.getTotalPages() - 1
    );
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.updateState();
    }
  }

  onResize() {
    this.currentPage = 0;
    this.slider.scrollLeft = 0;
    this.renderDots();
  }

  updateState() {
    const total = this.getTotalPages();
    const nav = this.querySelector('.rc-nav');

    if (nav) nav.style.display = total <= 1 ? 'none' : '';

    this.prevBtn.disabled = this.currentPage <= 0;
    this.nextBtn.disabled = this.currentPage >= total - 1;

    const dots = this.dotsContainer.querySelectorAll('.slider-counter__link--dots');
    dots.forEach((dot, i) => {
      dot.classList.toggle('slider-counter__link--active', i === this.currentPage);
    });
  }
}

customElements.define('reviews-carousel', ReviewsCarousel);
